import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({
  label,
  onChange,
  checked,
  help,
  disabled,
  className,
  id,
  key,
  ...rest
}) => (
  <label
    className={`container-check-custom ${className} ${
      disabled ? 'disabled' : ''
    }`}
  >
    {` ${label}`}
    <input
      id={id}
      key={key}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      {...rest}
    />
    <span className="checkmark" />
    {help && <small className="form-text text-muted">{help}</small>}
  </label>
);

Checkbox.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  help: PropTypes.string,
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Checkbox.defaultProps = {
  label: '',
  help: null,
  className: '',
  disabled: false,
  onChange: () => {},
  id: '',
  key: '',
};

export default Checkbox;
